import React from 'react';
import Modal from 'react-bootstrap/Modal';
import dayjs from 'dayjs';
import DangerouslyHTMLTextPriview from '../../Components/Common/DangerouslyHTMLTextPriview.js';

function EmailTempleteView({ show, onHide, row }) {
  if (!row) return null;

  return (
    <Modal show={show} onHide={onHide} centered size='lg' backdrop="static" className='custom-modal-main'>
      <Modal.Header closeButton className='custom-modal-header p-2'>
        <Modal.Title className='custom-modal-title'>Email Template Details</Modal.Title>
      </Modal.Header>
      <Modal.Body className=' modal-body-content'>
        <div className='fs-6 mb-2 d-flex gap-2 align-items-center'><strong>Name:</strong> <p className='mb-0' style={{fontSize: '14px'}}>{row.name ? row.name : ''}</p></div>
        <div className='fs-6 mb-2 d-flex gap-2 align-items-center'><strong>Date:</strong> <p className='mb-0' style={{fontSize: '12px'}}>{row.created_at ? dayjs(row.created_at).format('DD-MM-YY') : ''}</p></div>
        <div className='fs-6 mb-2 d-flex gap-2 align-items-center'><strong>Template:</strong> </div>
        <div className='modal-dangerously-content' style={{backgroundColor: '#f5f5f5', borderRadius: '10px'}}>
        <DangerouslyHTMLTextPriview content={row.content}/>
        </div>
        {/* Add more fields as needed */}
      </Modal.Body>
    </Modal>
  );
}

export default EmailTempleteView;
